export interface IBreadcrumb {
    name: string;
    url: string;
}

type SeoScriptProps = {
    breadcrumb: IBreadcrumb[];
};

export const BreadcrumbSeoScript = ({ breadcrumb }: SeoScriptProps) => {
    const itemListElement = breadcrumb
        ? breadcrumb.map((b, index) => {
              return {
                  '@type': 'ListItem',
                  position: index + 1,
                  item: {
                      '@id': window.location.origin + b.url,
                      name: b.name,
                  },
              };
          })
        : [];

    const data = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
    };

    return (
        <script
            id="seo-breadcrumbs"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
};
